export const EditIcon = () => { 
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
      >
        <path
          d="M17.1563 16.4028C17.1563 17.1737 16.5298 17.8238 15.7589 17.8238H4.5773C3.80642 17.8238 3.17992 17.1737 3.17992 16.4028V5.22115C3.17992 4.45028 3.80642 3.84653 4.5773 3.84653H11.0995V2.91553H4.5773C3.2928 2.91553 2.24805 3.93753 2.24805 5.22203V16.4028C2.24805 17.6873 3.2928 18.7548 4.5773 18.7548H15.758C17.0425 18.7548 18.0873 17.6864 18.0873 16.4028V9.90328H17.1554L17.1563 16.4028Z"
          fill="currentColor"
        />
        <path
          d="M18.2063 2.77376C17.5028 2.06939 16.2751 2.06939 15.5708 2.77376L9.32064 9.02389C9.26114 9.08339 9.21826 9.15864 9.19814 9.24002L8.54014 11.8746C8.50076 12.033 8.54714 12.201 8.66264 12.3174C8.75101 12.4058 8.87001 12.4539 8.99164 12.4539C9.02926 12.4539 9.06689 12.4495 9.10451 12.4399L11.74 11.781C11.8223 11.7609 11.8966 11.718 11.9561 11.6585L18.2063 5.40839C18.558 5.05664 18.7523 4.58851 18.7523 4.09064C18.7523 3.59276 18.5589 3.12551 18.2063 2.77376ZM11.3891 10.9086L9.63214 11.3479L10.0714 9.59089L15.2418 4.42051L16.5595 5.73826L11.3891 10.9086ZM17.5474 4.74951L17.2184 5.07851L15.9006 3.76076L16.2296 3.43176C16.5814 3.08001 17.1956 3.08001 17.5474 3.43176C17.7233 3.60764 17.8204 3.84126 17.8204 4.09064C17.8204 4.34001 17.7233 4.57364 17.5474 4.74951Z"
          fill="currentColor"
        />
        <line x1="5" y1="15.5" x2="15" y2="15.5" stroke="#08C7B0" />
      </svg>
    );
}